module.exports = __webpack_public_path__ + "resources/img/bg_cover_marketplace_v2.287fb954dfe9a81a2df69bbd7ce3c5d8.png";